import { layarServer } from '../utils/layarServer';

/**
 * Pengirim data ke layar pelanggan (/layar di server). Kasir memanggil `kirim(pesan)` tiap isi keranjang / pembayaran berubah;
 * pengiriman baru jalan setelah kasir menekan "Layar Pelanggan" (sesi dibuat). Satu pengirim dipakai bersama (tahan pindah halaman).
 */
export const useLayarPelanggan = () => layarServer.kirim;
